if (!customElements.get('dog-size-rows')) {
  customElements.define(
    'dog-size-rows',
    class DogSizeRows extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.idInput = this.form?.querySelector('input[name="id"]');
        this.priceLabel = document.querySelector('[data-dog-atc-price]');
        this.stickyPrice = document.querySelector('[data-dog-sticky-price]');
        this.stickySize = document.querySelector('[data-dog-sticky-size]');
        this.inputs = this.querySelectorAll('input[type="radio"]');
        this.inputs.forEach((input) => input.addEventListener('change', () => this.select(input)));
        const selected = this.querySelector('input:checked') || this.inputs[0];
        if (selected) this.select(selected, false);
      }

      select(input, updateUrl = true) {
        if (!input) return;
        this.querySelectorAll('.dog-size').forEach((row) => row.classList.remove('is-selected'));
        input.closest('.dog-size')?.classList.add('is-selected');
        const id = input.value;
        if (this.idInput) {
          this.idInput.value = id;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const price = input.dataset.price;
        const size = input.dataset.label;
        const atc = document.querySelector('.dog-pdp__atc span:not(.visually-hidden)');
        const template = document.querySelector('.dog-pdp__atc')?.dataset.atcTemplate;
        if (atc && template && price) atc.textContent = template.replace('PRICE', price);
        if (this.priceLabel && price) this.priceLabel.textContent = price;
        if (this.stickyPrice && price) this.stickyPrice.textContent = price;
        const stickyButton = document.querySelector('[data-sticky-submit]');
        if (stickyButton && template && price) {
          stickyButton.childNodes[0].textContent = ` ${template.replace('PRICE', price)} `;
        }
        document.querySelector('.dog-buy dog-gift-wrap')?.syncAtcPrice?.();
        if (this.stickySize && size) this.stickySize.textContent = size;
        if (updateUrl && history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          history.replaceState({}, '', url.toString());
        }
      }
    }
  );
}

if (!customElements.get('dog-gift-wrap')) {
  customElements.define(
    'dog-gift-wrap',
    class DogGiftWrap extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-gift-toggle]');
        this.note = this.querySelector('[data-gift-note]');
        this.fields = this.querySelector('[data-gift-fields]');
        this.variantId = this.dataset.variantId;
        this.lineKey = this.dataset.lineKey;
        this.toggle?.addEventListener('change', () => this.sync());
        this.note?.addEventListener('input', () => this.limitNote());
        this.syncVisibility();
        this.syncAtcPrice();
      }

      syncVisibility() {
        if (this.fields) this.fields.hidden = !this.toggle?.checked;
      }

      limitNote() {
        if (this.note && this.note.value.length > 150) {
          this.note.value = this.note.value.slice(0, 150);
        }
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: window.Shopify?.currency?.active || 'USD',
          }).format(Number(cents) / 100);
        } catch (error) {
          return `$${(Number(cents) / 100).toFixed(2)}`;
        }
      }

      syncAtcPrice() {
        if (this.closest('cart-drawer')) return;
        const selected = document.querySelector('.dog-sizes input:checked');
        const paintingCents = Number(selected?.dataset.priceCents || 0);
        const giftCents = Number(this.dataset.giftCents || 0);
        const total = paintingCents + (this.toggle?.checked && giftCents ? giftCents : 0);
        if (!total) return;
        const price = this.formatMoney(total);
        const template = document.querySelector('.dog-pdp__atc')?.dataset.atcTemplate;
        const atc = document.querySelector('.dog-pdp__atc span:not(.visually-hidden)');
        if (atc && template) atc.textContent = template.replace('PRICE', price);
        const stickyButton = document.querySelector('[data-sticky-submit]');
        if (stickyButton && template) {
          stickyButton.childNodes[0].textContent = ` ${template.replace('PRICE', price)} `;
        }
      }

      giftPayload() {
        return {
          id: Number(this.variantId),
          quantity: 1,
          properties: this.note?.value ? { Note: this.note.value } : {},
        };
      }

      async addOrRemoveWrap() {
        if (!this.variantId) return { error: 'Gift wrap product is not assigned.' };
        const config = fetchConfig('javascript');
        const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
        if (this.toggle.checked) {
          const cart = await fetch(`${window.routes.cart_url}.js`).then((response) => response.json());
          const already = cart.items?.some((item) => String(item.variant_id) === String(this.variantId));
          if (already) return null;
          config.body = JSON.stringify({
            items: [this.giftPayload()],
            sections: sectionIds,
            sections_url: window.location.pathname,
          });
          const response = await fetch(`${window.routes.cart_add_url}`, config);
          return response.json();
        }
        const cart = await fetch(`${window.routes.cart_url}.js`).then((response) => response.json());
        const line = cart.items?.find((item) => String(item.variant_id) === String(this.variantId));
        if (!line) return null;
        config.body = JSON.stringify({
          id: line.key,
          quantity: 0,
          sections: sectionIds,
          sections_url: window.location.pathname,
        });
        const response = await fetch(`${window.routes.cart_change_url}`, config);
        return response.json();
      }

      applyCart(parsed) {
        const drawer = document.querySelector('cart-drawer');
        if (!parsed?.sections || !drawer) return;
        drawer.classList.toggle('is-empty', Number(parsed.item_count) === 0);
        drawer.renderContents(parsed);
        if (Number(parsed.item_count) > 0) drawer.open?.();
      }

      async sync() {
        this.syncVisibility();
        this.syncAtcPrice();
        if (!this.variantId) return;
        this.toggle?.setAttribute('aria-busy', 'true');
        try {
          const parsed = await this.addOrRemoveWrap();
          if (parsed?.status || parsed?.description) {
            this.toggle.checked = !this.toggle.checked;
            this.syncVisibility();
            this.syncAtcPrice();
            return;
          }
          this.applyCart(parsed);
        } finally {
          this.toggle?.removeAttribute('aria-busy');
        }
      }
    }
  );
}

if (!window.__dogGiftCartBound && typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
  window.__dogGiftCartBound = true;
  subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
    if (event.source !== 'product-form') return;
    const wrap = document.querySelector('.dog-buy dog-gift-wrap');
    if (!wrap?.querySelector('[data-gift-toggle]')?.checked) return;
    if (!wrap.dataset.variantId) return;
    await new Promise((resolve) => setTimeout(resolve, 80));
    const parsed = await wrap.addOrRemoveWrap();
    wrap.applyCart(parsed);
  });
}

if (!customElements.get('dog-pair-bundle')) {
  customElements.define(
    'dog-pair-bundle',
    class DogPairBundle extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-add-both]')?.addEventListener('click', () => this.addBoth());
      }

      async addBoth() {
        const ids = this.dataset.ids.split(',').filter(Boolean);
        if (!ids.length) return;
        const button = this.querySelector('[data-add-both]');
        button?.setAttribute('aria-disabled', 'true');
        const response = await fetch(`${window.routes.cart_add_url}`, {
          ...fetchConfig('javascript'),
          body: JSON.stringify({
            items: ids.map((id) => ({ id: Number(id), quantity: 1 })),
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        });
        const parsed = await response.json();
        document.querySelector('cart-drawer')?.renderContents(parsed);
        button?.removeAttribute('aria-disabled');
      }
    }
  );
}

if (!customElements.get('dog-complementary')) {
  customElements.define(
    'dog-complementary',
    class DogComplementary extends HTMLElement {
      connectedCallback() {
        const productId = this.dataset.productId;
        if (!productId) return;
        fetch(
          `${window.routes.product_recommendations_url}.json?product_id=${productId}&limit=3&intent=complementary`
        )
          .then((response) => response.json())
          .then((data) => this.render(data.products || []))
          .catch(() => {});
      }

      render(products) {
        if (!products.length) {
          this.hidden = true;
          return;
        }
        const list = this.querySelector('[data-rec-list]');
        if (!list) return;
        list.innerHTML = products
          .map((product) => {
            const variant = product.variants?.[0];
            const image = product.featured_image || product.images?.[0];
            const src = image?.src || image?.url || '';
            return `<li class="dog-rec">
              ${src ? `<img src="${src}" alt="" width="72" height="72" loading="lazy">` : ''}
              <div>
                <p class="dog-rec__title">${product.title}</p>
                <p class="dog-rec__price">${this.formatMoney(variant?.price ?? product.price)}</p>
              </div>
              <button type="button" class="dog-rec__add" data-id="${variant?.id}">${this.dataset.addLabel || 'Add'}</button>
            </li>`;
          })
          .join('');
        list.querySelectorAll('[data-id]').forEach((button) => {
          button.addEventListener('click', () => this.add(button.dataset.id, button));
        });
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: window.Shopify?.currency?.active || 'USD',
          }).format(Number(cents) / 100);
        } catch (error) {
          return (Number(cents) / 100).toFixed(2);
        }
      }

      async add(id, button) {
        button.setAttribute('aria-disabled', 'true');
        const response = await fetch(`${window.routes.cart_add_url}`, {
          ...fetchConfig('javascript'),
          body: JSON.stringify({
            items: [{ id: Number(id), quantity: 1 }],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        });
        const parsed = await response.json();
        document.querySelector('cart-drawer')?.renderContents(parsed);
      }
    }
  );
}

if (!customElements.get('dog-sticky-buy')) {
  customElements.define(
    'dog-sticky-buy',
    class DogStickyBuy extends HTMLElement {
      connectedCallback() {
        const buyBox = document.querySelector('[data-dog-buy-box]');
        if (!buyBox || window.matchMedia('(min-width: 750px)').matches) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            this.classList.toggle('is-visible', entries.every((entry) => !entry.isIntersecting));
          },
          { threshold: 0 }
        );
        this.observer.observe(buyBox);
        this.querySelector('[data-sticky-submit]')?.addEventListener('click', () => {
          document.querySelector('[data-dog-buy-box] [name="add"]')?.click();
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}

(() => {
  document.querySelectorAll('[data-dog-texture-media]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = document.querySelector('media-gallery');
      const mediaId = button.dataset.dogTextureMedia;
      if (!gallery || !mediaId || typeof gallery.setActiveMedia !== 'function') return;
      gallery.setActiveMedia(mediaId, false);
    });
  });
})();

(() => {
  const days = Number(document.querySelector('[data-paint-days]')?.dataset.paintDays || 0);
  const windowLabel = document.querySelector('[data-paint-days]')?.dataset.shipWindow;
  if (!days) return;
  const start = new Date();
  start.setDate(start.getDate() + days);
  const end = new Date(start);
  end.setDate(end.getDate() + 4);
  const format = (date) => date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  const range = `${format(start)}–${format(end)}`;
  document.querySelectorAll('[data-delivery-range]').forEach((node) => {
    node.textContent = node.dataset.template
      ? node.dataset.template.replace('{{ range }}', range)
      : windowLabel
        ? windowLabel.replace('[X]', range)
        : range;
  });
})();
